module.exports = __webpack_public_path__ + "static/media/ins10.20761a5a.jpg";